import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";

/**
 * Shared dialog for confirming campaign status changes.
 *
 * Props:
 * - open: boolean
 * - onOpenChange: (open: boolean) => void
 * - campaignName: string
 * - currentStatusLabel: string
 * - currentStatusBadgeClassName: string
 * - newStatusLabel: string | null
 * - newStatusBadgeClassName: string
 * - onConfirm: () => void
 */
export function CampaignStatusChangeDialog({
  open,
  onOpenChange,
  campaignName,
  currentStatusLabel,
  currentStatusBadgeClassName,
  newStatusLabel,
  newStatusBadgeClassName,
  onConfirm,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/20">
            <ArrowRight className="h-6 w-6 text-blue-600 dark:text-blue-400" />
          </div>
          <AlertDialogTitle className="text-center text-xl">
            Change Campaign Status
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center space-y-2">
            <p>Are you sure you want to change the campaign status?</p>
            <div className="mt-4 p-3 bg-muted rounded-lg text-left">
              <p className="font-semibold text-foreground text-sm">
                {campaignName || "Untitled Campaign"}
              </p>
              <div className="flex items-center gap-2 mt-2 text-xs">
                <Badge variant="outline" className={`font-normal ${currentStatusBadgeClassName || ""}`}>
                  {currentStatusLabel}
                </Badge>
                <ArrowRight className="h-3 w-3 text-muted-foreground" />
                <Badge className={newStatusBadgeClassName}>
                  {newStatusLabel || "Unknown"}
                </Badge>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2 sm:gap-2">
          <AlertDialogCancel className="mt-0" onClick={() => onOpenChange(false)}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-blue-600 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-700"
          >
            <ArrowRight className="mr-2 h-4 w-4" />
            Change Status
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default CampaignStatusChangeDialog;

